import { Args, BaseService } from './BaseService';
import { resources } from '../resources';
import { AxiosPromise, type RawAxiosRequestConfig } from 'axios';
import { EntryRequestDto } from '../models/invitation/EntryRequestDto';
import { CreateUpdateEntryRequest } from '../models/request/invitation/CreateUpdateEntryRequest';
import { EntryRequestStateChangeRequest } from '../models/request/invitation/EntryRequestStateChangeRequest';

export class EntryRequestService extends BaseService {
  public createEntryRequest(invitationId: string, body: CreateUpdateEntryRequest, args?: Args): AxiosPromise<EntryRequestDto> {
    return this.post<EntryRequestDto>(resources.createEntryRequest, body, { invitationId, ...args });
  }

  public updateEntryRequest(entryRequestId: string, body: CreateUpdateEntryRequest, args?: Args): AxiosPromise<EntryRequestDto> {
    return this.put<EntryRequestDto>(resources.updateEntryRequest, body, { id: entryRequestId, ...args });
  }

  public deleteEntryRequest(entryRequestId: string, args?: Args): AxiosPromise<void> {
    return this.delete<void>(resources.deleteEntryRequest, { id: entryRequestId, ...args });
  }

  public changeEntryRequestState(entryRequestId: string, body: EntryRequestStateChangeRequest, args?: Args): AxiosPromise<EntryRequestDto> {
    return this.put<EntryRequestDto>(resources.changeEntryRequestState, body, { id: entryRequestId, ...args });
  }

  public getEntryRequestsByCompany(args?: Args, options: RawAxiosRequestConfig = {}): AxiosPromise<EntryRequestDto[]> {
    return this.get<EntryRequestDto[]>(resources.getEntryRequestsByCompany, args, options);
  }

  public getEntryRequestById(entryRequestId: string, args?: Args): AxiosPromise<EntryRequestDto> {
    return this.get<EntryRequestDto>(resources.getEntryRequestById, { id: entryRequestId, ...args });
  }
}
